/**
 * 请求工具
 */
import axios from 'axios'
import { ElMessage } from 'element-plus'

// 创建axios实例
const service = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '', // api的base_url
  timeout: 60000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // 添加认证token
    const token = localStorage.getItem('tc_t') || localStorage.getItem('token') || window.App?.token
    if (token) {
      config.headers['X-Auth-Token'] = token
    }
    return config
  },
  error => {
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果是文件下载
    if (response.config.responseType === 'blob') {
      return response
    }
    
    // 这里根据后端的响应格式进行调整
    if (res.code !== undefined && res.code !== 200) {
      // 增加对业务逻辑中返回 code=401 的处理
      if (res.code === 401) {
        ElMessage({
          message: '登录已过期，请重新登录',
          type: 'error',
          duration: 3 * 1000
        })
        
        // 清除本地存储的Token和用户信息
        localStorage.removeItem('tc_t')
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        localStorage.removeItem('allowUpdate')
        
        // 延迟刷新页面，触发路由守卫跳转到登录页
        setTimeout(() => {
          window.location.reload()
        }, 1000)
        
        return Promise.reject(new Error(res.message || '未授权访问'))
      }

      ElMessage({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    
    // 处理 401 未授权 (Token过期或无效)
    if (error.response && error.response.status === 401) {
      ElMessage({
        message: '登录已过期，请重新登录',
        type: 'error',
        duration: 3 * 1000
      })
      
      // 清除本地存储的Token和用户信息
      localStorage.removeItem('tc_t')
      localStorage.removeItem('token')
      localStorage.removeItem('username')
      localStorage.removeItem('allowUpdate')
      
      // 延迟刷新页面，触发路由守卫跳转到登录页
      setTimeout(() => {
        window.location.reload()
      }, 1000)
      
      return Promise.reject(error)
    }

    ElMessage({
      message: error.message || '网络错误',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export { service as request }
export { service as apiRequest }